import { render, staticRenderFns } from "./TermService.vue?vue&type=template&id=ddf6608c&scoped=true"
import script from "./TermService.vue?vue&type=script&lang=js"
export * from "./TermService.vue?vue&type=script&lang=js"
import style0 from "./TermService.vue?vue&type=style&index=0&id=ddf6608c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddf6608c",
  null
  
)

export default component.exports